import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { IOrganisationTag } from '../../interfaces/organisation-tag';
import { ITagEntity } from '../../interfaces/tag-entity';

import { MessageService } from 'primeng';
import { Message } from '../../classes/Message';
import { TaggingService } from '../../services/tagging.service';

@Component({
  selector: 'tagging-tags-details',
  templateUrl: 'tagging-tags-details.component.html',
  styleUrls: ['tagging-tags-details.component.css'],
})
export class TaggingTagsDetailsComponent implements OnInit {
  constructor(private taggingService: TaggingService, private messageService: MessageService) {}

  public tags: ITagEntity[];
  showTagSelector: boolean = false;

  @Output() selectorClosed: EventEmitter<{ tagSet: number; tags: ITagEntity[] }> =
    new EventEmitter<{ tagSet: number; tags: ITagEntity[] }>();

  public tagSet: IOrganisationTag[][] = [];
  currentTagSet: number;

  public tagColumns: {}[];

  // a list of organisation tags to display/modify within this component
  @Input('organisationTags')
  public set organisationTags(value: IOrganisationTag[]) {
    //console.log("Set value on tag details component.. ", value);

    // split the org tags into separate arrays for each 'set' (set 0 = the NOT set)
    // we are not limited to 3 OR'd tag sets but this is the current setup for the UI
    if (value) {
      for (var i = 0; i <= 3; i++) this.tagSet[i] = value.filter((x) => x.tagSet == i);
    }

    //console.log("tagSet ", this.tagSet);
  }

  @Input('readOnly') readOnly: boolean;

  ngOnInit() {
    this.tagColumns = [
      { name: 'Tags', index: 1 },
      { name: 'Or', index: 2 },
      { name: 'Or', index: 3 },
      { name: 'Not', index: 0 },
    ];

    // load tags to show in selector
    this.taggingService.getAllTags().subscribe(
      (tags) => {
        this.tags = tags;
      },
      (error) => {
        // todo: use message service to show error
        this.messageService.add(Message.Error('An error occurred loading Tags'));
      },
    );
  }

  onTagsClicked(tagSet: number, event) {
    this.currentTagSet = tagSet;

    // todo: modify the tags array to select those currently selected for this tagSet
    this.tags.forEach(
      (x) =>
        (x.selected =
          this.tagSet[this.currentTagSet].findIndex((y) => y.tagEntity.name == x.name) >= 0),
    );

    this.showTagSelector = true;
  }

  onTagSelectorClosed() {
    // filter so only checked tags are in the array
    let checked = this.tags.filter((x) => x.selected);

    // emit the event so parent component can now update organisation tags
    this.selectorClosed.emit({ tagSet: this.currentTagSet, tags: checked });
    this.currentTagSet = null;
  }

  getTagDetails(index: number) {
    let response: string = '';

    this.tagSet[index].forEach((x, i) => {
      response += x.tagEntity.name;
      if (i < this.tagSet[index].length - 1) response += ' AND ';
    });

    return response;
  }

  hasTags(): boolean {
    let result: boolean = false;

    if (this.tagSet) {
      this.tagSet.forEach((x) => {
        if (x.length > 0) result = true;
      });
    }

    return result;
  }
}
